<template>
<v-container>
   <v-card flat>
       <v-card-text class="justify-center">
      <p class="text-xs-center headline "><strong>
        <i v-if="errorFlag" class="fa fa-ban" color="red" aria-hidden="true"></i>
        &nbsp; {{error}} </strong> </p>
        <p>{{errorDetail}}  
          </p>
     </v-card-text>
     <v-card-actions v-if="!errorFlag"   class="justify-center">
       <ScaleLoader color = '#36D7B7'
        ></ScaleLoader>
       <br/>
       </v-card-actions>
  </v-card>
  </v-container>
</template>
<style>
</style>
<script>
//import UserModel from '../../api/service/UserService.js';

import ReportLogModel from '../../service/ReportLogService';
import {RotateSquare2} from 'vue-loading-spinner'
import { ScaleLoader	 } from '@saeris/vue-spinners'
import { PacmanLoader	 } from '@saeris/vue-spinners'
import FileDownload from 'js-file-download'
import axios from 'axios'
import ApiConfig2 from '@/api/config/config.js'
//var fileDownload = require('js-file-download');
 

export default {
   components: {
      RotateSquare2,
      ScaleLoader	,
      PacmanLoader
  },
  data: () => ({
    error: "Downloading Files ..",
    errorFlag : false,
errorDetail:""
  }),
  created() {
    this.getDownloadLink()
  },
  created3 () {
    console.log(this.$route.query)
    var $download 
    var url
    var $id = this.$route.query.id
    var navigate = this.$router
    /*Security.encode({
      "id":$id,
      "user":this.User=this.$store.getters.userInfo
    }).then($encrypted => {*/
    axios({
    //  url: 'http://localhost:3063/reportLog/download/'+$id,
      url: ApiConfig2.baseUrl+'/reportLog/download/'+$id,
      method: 'GET',
      timeout: 180000, // Let's say you want to wait at least 180 seconds
      headers: {
        "X-Auth-Token":JSON.stringify({
          "id":$id,
          "user":this.User=this.$store.getters.userInfo
        }).toString('base64')
      },
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', response.headers['x-suggested-filename']); //or any other extension
      document.body.appendChild(link);
      link.click();
     navigate.replace('/reportSubscriptions')
    /*}).catch(error =>
     console.log(error))*/
    }).catch(error =>  {
     console.log(error)
      if(error) {
this.setError('')}
    })
    /*ReportLogModel.download(this.$route.query.id).then(response=> {
      try {
      let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      console.log(blob)
      url = window.URL.createObjectURL(blob)
      //window.open(url) //
      //console.log(response)
      // FileDownload(response.data, 'Detail_Blast.xlsx');
      /*console.log(response.headers)
      console.log(response.data.data)
       const url = window.URL.createObjectURL(new Blob([response.data.data.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.xlsx') //or any other extension
      document.body.appendChild(link)
      link.click()
      } catch(exception) {
        console.log(exception.message)
      }
      
    }).catch(error => {
      conso+le.log(error)
    });*/
    //var navigate = this.$router;
     
    /*setTimeout(() => {
          navigate.replace('/reportSubscriptions')
        }, 5000);*/
  },
  
  methods: {
    async getDownloadLink(){
      let $link =await ReportLogModel.getDownloadLink(this.$route.query.id)
      var link = document.createElement("a");
      console.log($link.data)
      link.download = this.$route.query.id;
      //link.href = 'https://new-reports-media.s3.amazonaws.com/reports/'+this.$route.query.id+'xlsx'
      link.href = $link.data.data.link
      link.click();
      this.$router.replace('/reportSubscriptions')
    },
    setError(error) {
      this.error = 'We are Sorry!!'
      this.errorFlag = true
this.errorDetail = "The downloadlink had expired or you may not be authorized to download the report"
    }
  }
};
</script>

<style  scoped>
  .style-input {
    padding:0px;
    margin:0px;
    width:100%;
  }
  .style-input1 {
    background-color:yellow;
  }
</style>
